export const CLEAR_SYNDICATE = 'CLEAR_SYNDICATE';
export const CLEAR_STATE = 'CLEAR_STATE';

export const DELETE_SYNDICATE = 'DELETE_SYNDICATE';
export const DELETE_SYNDICATE_ERROR = 'DELETE_SYNDICATE_ERROR';
export const DELETE_SYNDICATE_SUCCESS = 'DELETE_SYNDICATE_SUCCESS';

export const GET_SYNDICATES = 'GET_SYNDICATES';
export const GET_SYNDICATES_ERROR = 'GET_SYNDICATES_ERROR';
export const GET_SYNDICATES_SUCCESS = 'GET_SYNDICATES_SUCCESS';

export const GET_SYNDICATE = 'GET_SYNDICATE';
export const GET_SYNDICATE_ERROR = 'GET_SYNDICATE_ERROR';
export const GET_SYNDICATE_SUCCESS = 'GET_SYNDICATE_SUCCESS';

export const GET_ADMINISTRATORS = 'GET_ADMINISTRATORS';
export const GET_ADMINISTRATORS_ERROR = 'GET_ADMINISTRATORS_ERROR';
export const GET_ADMINISTRATORS_SUCCESS = 'GET_ADMINISTRATORS_SUCCESS';

export const SAVE_SYNDICATE = 'SAVE_SYNDICATE';
export const SAVE_SYNDICATE_ERROR = 'SAVE_SYNDICATE_ERROR';
export const SAVE_SYNDICATE_SUCCESS = 'SAVE_SYNDICATE_SUCCESS';

export const SAVE_SYNDICATE_LINKS = 'SAVE_SYNDICATE_LINKS';
export const SAVE_SYNDICATE_LINKS_SUCCESS = 'SAVE_SYNDICATE_LINKS';
export const SAVE_SYNDICATE_LINKS_ERROR = 'SAVE_SYNDICATE_LINKS_ERROR';

export const SAVE_PASSWORD = 'SAVE_PASSWORD';
export const SAVE_PASSWORD_ERROR = 'SAVE_PASSWORD_ERROR';
export const SAVE_PASSWORD_SUCCESS = 'SAVE_PASSWORD_SUCCESS';

export const SAVE_ADMINISTRATORS = 'SAVE_ADMINISTRATORS';
export const SAVE_ADMINISTRATORS_ERROR = 'SAVE_ADMINISTRATORS_ERROR';
export const SAVE_ADMINISTRATORS_SUCCESS = 'SAVE_ADMINISTRATORS_SUCCESS';

export const SAVE_COMMON_CHARGE = 'SAVE_COMMON_CHARGE';
export const SAVE_COMMON_CHARGE_ERROR = 'SAVE_COMMON_CHARGE_ERROR';
export const SAVE_COMMON_CHARGE_SUCCESS = 'SAVE_COMMON_CHARGE_SUCCESS';

export const SAVE_DOCUMENT = 'SAVE_DOCUMENT';
export const SAVE_DOCUMENT_ERROR = 'SAVE_DOCUMENT_ERROR';
export const SAVE_DOCUMENT_SUCCESS = 'SAVE_DOCUMENT_SUCCESS';



// WEBPACK FOOTER //
// ./src/components/Syndicates/constants.js